export const apiKeyNews = () => {
    if(window.location.href.includes("https://vtrc.redcross.or.th/")){
        // return 'fd77b56f-1489-4fb1-a094-a614f0d16198'
        return 'ZmQ3N2I1NmYtMTQ4OS00ZmIxLWEwOTQtYTYxNGYwZDE2MTk4'
    }else if(window.location.href.includes("https://uat-vtrc.redcross.or.th/")){
        // return '1080670e-926f-49e3-b798-63bb75f47b7d'
        return 'MTA4MDY3MGUtOTI2Zi00OWUzLWI3OTgtNjNiYjc1ZjQ3Yjdk'
	}else if(window.location.href.includes("http://localhost:3000/") || window.location.href.includes("http://192.168.0.105:3000/")){
        return 'MTA4MDY3MGUtOTI2Zi00OWUzLWI3OTgtNjNiYjc1ZjQ3Yjdk'
        // return '1080670e-926f-49e3-b798-63bb75f47b7d'
    }
}